import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  getTourTitles,
  create_private_tour,
  getAllOffers,
  deletePrivateTour,
  editPrivateTour,
  deleteLastDayTour,
  editDatePrivateTour,
  editDayPrivateTour,
  getAllMyPackages,
} from "./offerAxios";

//1- Get All Tour Titles
export const GetAllTourTitles = createAsyncThunk(
  "offer/get-all-tourtitles",
  async (_, thunkAPI) => {
    try {
      const response = await getTourTitles();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//2- Get All Offers
export const GetAllOffers = createAsyncThunk(
  "offer/get-all-offers",
  async (id, thunkAPI) => {
    try {
      const response = await getAllOffers(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//3- Get All My Offers
export const GetAllMyOffers = createAsyncThunk(
  "offer/get-all-my-offers",
  async (id, thunkAPI) => {
    try {
      const response = await getAllMyPackages(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//4- Create Private Tour
export const Create_private_tour = createAsyncThunk(
  "offer/create-private-tour",
  async (data, thunkAPI) => {
    try {
      return create_private_tour(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//5- Delete Private Tour
export const DeletePrivateTour = createAsyncThunk(
  "offer/delete-private-tour",
  async (offer_id, thunkAPI) => {
    try {
      return deletePrivateTour(offer_id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//6- edit Private Tour
export const EditPrivateTour = createAsyncThunk(
  "offer/edit-private-tour",
  async (data, thunkAPI) => {
    try {
      return editPrivateTour(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//7- Delete last day tour
export const DeleteLastDayTour = createAsyncThunk(
  "offer/delete-lastday-tour",
  async (id, thunkAPI) => {
    try {
      return deleteLastDayTour(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//8- Edit Date Private Tour
export const EditDatePrivateTour = createAsyncThunk(
  "offer/edit-date-private-tour",
  async (data, thunkAPI) => {
    try {
      return editDatePrivateTour(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//9- Edit Date Private Tour
export const EditDayPrivateTour = createAsyncThunk(
  "offer/edit-day-private-tour",
  async (data, thunkAPI) => {
    try {
      return editDayPrivateTour(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Define reset state action
export const resetStateOffer = createAction("Reset_all");

const initialState = {
  data: [],
  tour_titles: [],
  accommodations: [],
  day_tours: [],
  all_offers: [],
  single_offer: [],
  my_packages: [],
  package_offers: [],

  isTourTitlesSuccess: false,
  isAllMyPackageSuccess: false,
  isLoading: false,
  isSuccess: false,
  isOffersSuccess: false,
  isError: false,
  isCreated: false,
  isDelete: false,
  isEdit: false,
  message: "",
  item: false,
  show: false,
};

// Country Slice
export const offerSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {
    setItem: (state, { payload }) => {
      state.item = payload;
    },
    resetIsCreated: (state) => {
      state.isCreated = false; // Reset isCreated
    },
    resetIsDelete: (state) => {
      state.isDelete = false; // Reset isCreated
    },
    resetIsEdit: (state) => {
      state.isEdit = false; // Reset isCreated
    },
    resetOffers: (state) => {
      state.isOffersSuccess = false; // Reset isCreated
    },
    resetMyPackages: (state) => {
      state.isAllMyPackageSuccess = false; // Reset isCreated
    },
  },

  extraReducers: (builder) => {
    builder
      // Get All Tour Titles
      .addCase(GetAllTourTitles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetAllTourTitles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isTourTitlesSuccess = true;
        state.tour_titles = action.payload;
      })
      .addCase(GetAllTourTitles.rejected, (state, action) => {
        state.isLoading = false;
        state.isTourTitlesSuccess = false;
        state.message = "An error occurred";
      })

      // Create Private Tour
      .addCase(Create_private_tour.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(Create_private_tour.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isCreated = true;
        toast.success(action.payload?.message);
      })
      .addCase(Create_private_tour.rejected, (state, action) => {
        state.isLoading = false;
        state.isCreated = false;
        toast.error(action.payload?.message);
      })

      // Get All Offers
      .addCase(GetAllOffers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetAllOffers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isOffersSuccess = true;
        state.isError = false;
        state.all_offers = action.payload?.data;
      })
      .addCase(GetAllOffers.rejected, (state, action) => {
        state.isLoading = false;
        state.isOffersSuccess = false;
        state.isError = true;
      })

      // Delete Private Tour
      .addCase(DeletePrivateTour.pending, (state) => {})
      .addCase(DeletePrivateTour.fulfilled, (state, action) => {
        state.isError = false;
        toast.success("Tour is Deleted Successfully");
      })
      .addCase(DeletePrivateTour.rejected, (state, action) => {})

      // Edit Private Tour
      .addCase(EditPrivateTour.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(EditPrivateTour.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isEdit = true;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(EditPrivateTour.rejected, (state, action) => {
        state.isLoading = false;
        state.isEdit = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Delete last day Tour
      .addCase(DeleteLastDayTour.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeleteLastDayTour.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isEdit = true;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(DeleteLastDayTour.rejected, (state, action) => {
        state.isLoading = false;
        state.isEdit = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Edit Date Private Tour
      .addCase(EditDatePrivateTour.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(EditDatePrivateTour.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isEdit = true;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(EditDatePrivateTour.rejected, (state, action) => {
        state.isLoading = false;
        state.isEdit = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Edit Day Private Tour
      .addCase(EditDayPrivateTour.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(EditDayPrivateTour.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isEdit = true;
        state.isError = false;
        toast.success(action.payload?.message);
      })
      .addCase(EditDayPrivateTour.rejected, (state, action) => {
        state.isLoading = false;
        state.isEdit = false;
        state.isError = true;
        toast.error(action.payload?.message);
      })

      // Get All My Offers
      .addCase(GetAllMyOffers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetAllMyOffers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isAllMyPackageSuccess = true;
        state.isError = false;
        state.my_packages = action.payload?.data;
      })
      .addCase(GetAllMyOffers.rejected, (state, action) => {
        state.isLoading = false;
        state.isAllMyPackageSuccess = false;
        state.isError = true;
      })

      // Reset state
      .addCase(resetStateOffer, () => initialState);
  },
});

export default offerSlice.reducer;
export const {
  setItem,
  resetIsCreated,
  resetIsDelete,
  resetIsEdit,
  resetOffers,
  resetMyPackages,
} = offerSlice.actions;
export const resetAllOffers = () => (dispatch) => {
  dispatch(resetStateOffer());
};
